export default {"src":"/_next/static/media/aboutbaner.db59d8f4.gif","height":230,"width":230,"blurWidth":0,"blurHeight":0};